export const queryOptions = { refetchOnMount: true, retry: false, keepPreviousData: true };
